import { render, staticRenderFns } from "./biddingInformationDetails.vue?vue&type=template&id=921bc7a4&scoped=true"
import script from "./biddingInformationDetails.vue?vue&type=script&lang=js"
export * from "./biddingInformationDetails.vue?vue&type=script&lang=js"
import style0 from "./biddingInformationDetails.vue?vue&type=style&index=0&id=921bc7a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921bc7a4",
  null
  
)

export default component.exports